import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import { getClassNameFactory } from "../../../../utilities/classNames/";
import Menu from "./Menu";

var rehydrator = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var getClassName, childrenNode, reactifiedChildren, props, href, fallbackHref;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getClassName = getClassNameFactory("SiteHeaderMenu");
            childrenNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "children"
            })));
            _context.next = 4;
            return rehydrateChildren(childrenNode);

          case 4:
            reactifiedChildren = _context.sent;
            props = {
              title: domNode.getAttribute("data-title"),
              ariaLabel: domNode.getAttribute("data-aria-label"),
              children: reactifiedChildren,
              // these are supplied via `injectPropsToChildren`
              expanded: false,
              setOpenMenu: function setOpenMenu() {},
              currentMenu: ""
            };
            href = domNode.getAttribute("data-href");
            fallbackHref = domNode.getAttribute("data-fallback-href");

            if (href && href.length) {
              props.href = href;
            }

            if (fallbackHref && fallbackHref.length) {
              props.fallbackHref = fallbackHref;
            }

            return _context.abrupt("return", /*#__PURE__*/React.createElement(Menu, props));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function rehydrator(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export default rehydrator;